import { api } from './api';
import type { Post, PostDetail } from '../types';

export const contentApi = {
  scrape: (niche: string) =>
    api.post<{ posts: Post[]; scraped_accounts: string[]; new_count: number }>('/content/scrape', { niche }),
  listPosts: (niche: string, sort = 'viral', limit = 20) =>
    api.get<Post[]>(`/content/posts?niche=${encodeURIComponent(niche)}&sort=${sort}&limit=${limit}`),
  ocr: (postId: number) =>
    api.post<{ post_id: number; image_text: string | null }>(`/content/ocr/${postId}`),
  rewrite: (postId: number, niche: string, isRegeneration = false) =>
    api.post<{ rewrite_id: number; rewritten_text: string; hashtags: string | null }>('/content/rewrite', {
      post_id: postId, niche, is_regeneration: isRegeneration,
    }),
  hashtags: (postId: number) =>
    api.get<{ post_id: number; hashtags: string | null }>(`/content/hashtags/${postId}`),
  assignPost: (postId: number) => api.post<{ queue_id: number; status: string }>(`/content/posts/${postId}/assign`, {}),
  completePost: (postId: number) => api.post<{ status: string }>(`/content/posts/${postId}/complete`, {}),
  getPostDetail: (postId: number) => api.get<PostDetail>(`/content/posts/${postId}`),
};
